import React, { useState, useEffect } from "react";
import "./HomeS4.css";
import HS4C1P2ImgL1 from "../../../Assets/Svg/HomeS4/HS4C1P2L1.svg";
import HS4C1P2ImgL2 from "../../../Assets/Svg/HomeS4/HS4C1P2L2.svg";
import HS4C1P2ImgL3 from "../../../Assets/Svg/HomeS4/HS4C1P2L3.svg";
import HS4C1P2ImgL4 from "../../../Assets/Svg/HomeS4/HS4C1P2L4.svg";
import HS4C1P2LMob from "../../../Assets/Svg/HomeS4/HS4C1P2LMob.svg";
import HomeS1P2 from "../../../Assets/Svg/HomeS1P2.svg";

export default function HomeS4() {
  const isMobile = window.innerWidth <= 768;

  return (
    <>
      <div className="HomeS4">
        <div className="HS4C1P1">
          <span>xam</span> Rotating phases
        </div>
        <div className="HS4C1">
          <div className="HS4C1P2">
            <div className="HS4C1P2Box1">
              <div className="HS4C1P2Box1C">
                <img src={isMobile ? HS4C1P2LMob : HS4C1P2ImgL1} alt="" className="HS4C1P2ImgL1" />
                <div className="HS4C1P2Box1CText">
                  (Scan - <span>OCR</span>)
                </div>
              </div>
              <HS4C1P2Circle
                Number={<>01</>}
                Text={
                  <>
                    Scan <br /> Document
                  </>
                }
              />
            </div>
            <div className="HS4C1P2Box2">
              <div className="HS4C1P2Box2C">
                <img src={isMobile ? HS4C1P2LMob : HS4C1P2ImgL2} alt="" className="HS4C1P2ImgL2" />
                <div className="HS4C1P2Box2CText">
                  (<span>Store</span> - <span>Classify</span>)
                </div>
              </div>
              <HS4C1P2Circle
                Number={<>02</>}
                Text={
                  <>
                    Get It <br />
                    Organized
                  </>
                }
              />
            </div>
            <div className="HS4C1P2Box3">
              <div className="HS4C1P2Box3C">
                <img src={isMobile ? HS4C1P2LMob : HS4C1P2ImgL3} alt="" className="HS4C1P2ImgL1" />
                <div className="HS4C1P2Box3CText">
                  (<span>Recognize</span>)
                </div>
              </div>
              <HS4C1P2Circle
                Number={<>03</>}
                Text={
                  <>
                    Get Reminded <br />
                    to Renew
                  </>
                }
              />
            </div>
            <div className="HS4C1P2Box4">
              <div className="HS4C1P2Box4C">
                <img src={isMobile ? HS4C1P2LMob : HS4C1P2ImgL4} alt="" className="HS4C1P2ImgL4" />
                <div className="HS4C1P2Box4CText">
                  (<span>Notify</span> – Renew)
                </div>
              </div>
              <HS4C1P2Circle
                Number={<>04</>}
                Text={
                  <>
                    Never Have an Expired <br /> Document Again.
                  </>
                }
              />
            </div>
          </div>
        </div>
        {/*  */}
        {/*  */}
        <div className="HS4C2">
          <div className="HS4C2P1">
            <span>xam</span> offering solution
          </div>
          <div className="HS4C2P2">
            <div className="HS4C2P2L">
              <div className="HS4C2P2LP2">
                <div className="HS4C2P2LP2Content">
                  <img src={HomeS1P2} alt="" className="HS4C2P2LP2Img" />
                  <div className="HS4C2P2LP2Text">Scan & Remind</div>
                </div>
              </div>
            </div>
            {/*  */}
            {/*  */}
            <div className="HS4C2P2R">
              <HS4C2P2RBox
                Para1={<>The system automatically scans your documents and sends push notifications before critical dates expire.</>}
                Para2={<>offering solution for instant expiration and push notification alerts.</>}
              />
              <HS4C2P2RBox
                Para1={<>Your scanned IDs, licenses, and documents are automatically categorized and stored in organized folders for quick access.</>}
                Para2={<>offering solution by for seamless file and folder management.</>}
              />
              <HS4C2P2RBox
                Para1={<>Set customized reminder windows weeks or months before your official documents reach their end date to avoid penalties.</>}
                Para2={<>Offering a solution with flexible reminder scheduling before official expiration.</>}
              />
              <HS4C2P2RBox
                Para1={<>Uploaded files from your camera, local storage, and messages are unified into a single deduplicated repository.</>}
                Para2={<>offering solution unified storage and duplicate elimination.</>}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function HS4C1P2Circle({ Number, Text }) {
  return (
    <>
      {" "}
      <div className="HomeS4P2">
        <div className="HomeS4P2Content">
          <div className="HomeS4P2Number">{Number}</div>
          <div className="HomeS4P2Text">{Text}</div>
        </div>
      </div>
    </>
  );
}
function HS4C2P2RBox({ LText, LBGColor, Para1, Para2 }) {
  return (
    <>
      <div className="HS4C2P2RBoxC">
        {/* <div className="P2RBoxCL" style={{ backgroundColor: LBGColor }}>
          {LText}
        </div> */}
        <div className="P2RBoxCR">
          <div className="P2RBoxCRP1">{Para1}</div>
          <div className="P2RBoxCRP2">
            <span>xam</span> {Para2}
          </div>
        </div>
      </div>
    </>
  );
}
